import {Container, interfaces} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import SystemConfig, { CONFIG_PARAMS } from "./SystemConfig";
import SystemDebug from "./SystemDebug";
import IStatesManager from "../states/IStatesManager";
import BaseStates from "../states/BaseStates";
import StatesManager from "../states/StatesManager";
import SystemPlatform from "./SystemPlatform";
import System from "./System";
import SystemInit from "./SystemInit";
import SystemTime from "./SystemTime";
import Messages from "../Messages";
import IErrorHandler from "../error/IErrorHandler";
import ErrorHandler from "../error/ErrorHandler";
import Fullscreen from "../ui/screen/Fullscreen";
import LoadingScreen from "../loader/LoadingScreen";
import Connect, {FETCH_TYPES} from "../connect/Connect";
import IConnectControl from "../connect/controllers/IConnectControl";
import ConnectControl from "../connect/controllers/ConnectControl";
import IAjaxConnect from "../connect/ajax/IAjaxConnect";
import ConnectAjaxInit from "../connect/ajax/ConnectAjaxInit";
import ConnectAjaxAdd from "../connect/ajax/ConnectAjaxAdd";
import ConnectAjaxEnd from "../connect/ajax/ConnectAjaxEnd";
import ConnectAjaxClose from "../connect/ajax/ConnectAjaxClose";
import ConnectAjaxBalance from "../connect/ajax/ConnectAjaxBalance";
import ConnectAjaxGetDeviceOpt from "../connect/ajax/ConnectAjaxGetDeviceOpt";
import ConnectAjaxSetDeviceOpt from "../connect/ajax/ConnectAjaxSetDeviceOpt";
import ConnectAjaxGetGameOpt from "../connect/ajax/ConnectAjaxGetGameOpt";
import ConnectAjaxSetGameOpt from "../connect/ajax/ConnectAjaxSetGameOpt";
import ConnectAjaxGetButtonOpt from "../connect/ajax/ConnectAjaxGetButtonOpt";
import ConnectSocket from "../connect/socket/ConnectSocket";
import FetchAjax from "../connect/FetchAjax";
import FontPreloader from "../loader/FontPreloader";
import InitWallet from "../wallet/InitWallet";
import Wallet from "../wallet/Wallet";

import Factory = interfaces.Factory;
import AbstractStates from "../states/AbstractStates";
import {connectFactory} from "../connect/connectFactory";
import ConnectAjaxGetGameSessions from "../connect/ajax/ConnectAjaxGetGameSessions";
import ConnectAjaxGetSessions from "../connect/ajax/ConnectAjaxGetSessions";
import ConnectAjaxGetLastOpts from "../connect/ajax/ConnectAjaxLastOpts";
import PlayerOptions from "../player/PlayerOptions";
import ConnectAjaxReplay from "../connect/ajax/ConnectAjaxReplay";
import Replay from "../replay/Replay";
import ConnectAjaxLogic from "../connect/ajax/ConnectAjaxLogic";
import Freespins from "../wallet/Freespins";
import ConnectAjaxPlatformSettings from "../connect/ajax/ConnectAjaxPlatformSettings";
import PostMessages from "./PostMessages";
import LoadingScreenNew from "../loader/LoadingScreenNew";
import ConnectAjaxSetButtonOpt from "../connect/ajax/ConnectAjaxSetButtonOpt";
import PlaytechPostMessages from "./PlaytechPostMessages";
import Settings from "../settings/Settings";

export function defineSystem(gameset: any, container: Container) {
    container.bind<any>(SERVICE_IDENTIFIER.Gameset).toConstantValue(gameset);

    container.bind<SystemConfig>(SERVICE_IDENTIFIER.SystemConfig).to(SystemConfig).inSingletonScope();
    container.bind<SystemPlatform>(SERVICE_IDENTIFIER.SystemPlatform).to(SystemPlatform).inSingletonScope();

    let config = container.get<SystemConfig>(SERVICE_IDENTIFIER.SystemConfig); //init config

    container.bind<SystemDebug>(SERVICE_IDENTIFIER.SystemDebug).to(SystemDebug).inSingletonScope();
    container.bind<AbstractStates>(SERVICE_IDENTIFIER.BaseStates).to(BaseStates).inSingletonScope();
    container.bind<IStatesManager>(SERVICE_IDENTIFIER.StatesManager).to(StatesManager).inSingletonScope();

    container.bind<System>(SERVICE_IDENTIFIER.System).to(System).inSingletonScope();
    container.bind<SystemInit>(SERVICE_IDENTIFIER.SystemInit).to(SystemInit).inSingletonScope();
    container.bind<SystemTime>(SERVICE_IDENTIFIER.SystemTime).to(SystemTime).inSingletonScope();
    container.bind<Messages>(SERVICE_IDENTIFIER.SystemMessages).to(Messages).inSingletonScope();
    container.bind<IErrorHandler>(SERVICE_IDENTIFIER.ErrorHandler).to(ErrorHandler).inSingletonScope();
    container.bind<Fullscreen>(SERVICE_IDENTIFIER.Fullscreen).to(Fullscreen).inSingletonScope();

    container.bind<Connect>(SERVICE_IDENTIFIER.Connect).to(Connect).inSingletonScope();
    container.bind<IConnectControl>(SERVICE_IDENTIFIER.ConnectControl).to(ConnectControl).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectInit).to(ConnectAjaxInit).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectAdd).to(ConnectAjaxAdd).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectEnd).to(ConnectAjaxEnd).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectClose).to(ConnectAjaxClose).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectBalance).to(ConnectAjaxBalance).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectReplay).to(ConnectAjaxReplay).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectLogic).to(ConnectAjaxLogic).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectWebsocket).to(ConnectSocket).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectGetDeviceOpt).to(ConnectAjaxGetDeviceOpt).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectSetDeviceOpt).to(ConnectAjaxSetDeviceOpt).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectGetGameOpt).to(ConnectAjaxGetGameOpt).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectSetGameOpt).to(ConnectAjaxSetGameOpt).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectGetButtonOpt).to(ConnectAjaxGetButtonOpt).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectSetButtonOpt).to(ConnectAjaxSetButtonOpt).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectGetLastOpts).to(ConnectAjaxGetLastOpts).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectPlatformSettings).to(ConnectAjaxPlatformSettings).inSingletonScope();

    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectGetSessions).to(ConnectAjaxGetSessions).inSingletonScope();
    container.bind<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectGetGameSessions).to(ConnectAjaxGetGameSessions).inSingletonScope();

    // container.bind<FetchAjax>(SERVICE_IDENTIFIER.FetchAjax).to(FetchAjaxTest).inSingletonScope();
    container.bind<FetchAjax>(SERVICE_IDENTIFIER.FetchAjax).to(FetchAjax).inSingletonScope();

    container.bind<PlayerOptions>(SERVICE_IDENTIFIER.PlayerOptions).to(PlayerOptions).inSingletonScope();

    container.bind<Factory<IAjaxConnect>>(SERVICE_IDENTIFIER.ConnectFactory).toFactory<IAjaxConnect>(connectFactory);

    container.bind<FontPreloader>(SERVICE_IDENTIFIER.FontPreloader).to(FontPreloader).inSingletonScope();

    //define madmax
    container.bind<InitWallet>(SERVICE_IDENTIFIER.InitWallet).to(InitWallet).inSingletonScope();
    container.bind<Wallet>(SERVICE_IDENTIFIER.Wallet).to(Wallet).inSingletonScope();
    container.bind<Freespins>(SERVICE_IDENTIFIER.Freespins).to(Freespins).inSingletonScope();

    container.bind<Replay>(SERVICE_IDENTIFIER.Replay).to(Replay).inSingletonScope();
}


export function defineCustomSystemParts(container: Container, settings: Settings): void {
	if(settings.getPlatform().includes("playtech")) {
        //@ts-expect-error ts complains about argument mismatch in postMessage (), but this is internal method, we don't care
		container.bind<PostMessages>(SERVICE_IDENTIFIER.PostMessages).to(PlaytechPostMessages).inSingletonScope();
	}else {
		container.bind<PostMessages>(SERVICE_IDENTIFIER.PostMessages).to(PostMessages).inSingletonScope();
	}
}